import React from 'react';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import WorkShopTypeDropdown from '../WorkshopTypeDropdown';
import OpeningHoursDropdown from '../OpeningHoursDropdown';
import DistanceDropdown from '../DistanceDropdown';
import { ICountry, IState, Replacement } from '../../../interface';
import localesReplacement from '../../../utils/localesReplacement';
import { connect } from 'react-redux';
import _ from 'lodash';
import { EUROPEAN_WITHOUT_SERVICE_TYPE_FILTER, NODISTANCECOUNTRIES } from '../../../constants';

const cx = classnames.bind(style);

export interface IProps {
  overlay: boolean;
  replacements: Replacement;
  setOverlay: (value: boolean) => void;
  country: ICountry;
}

//Filter for workshop type & workshop rating & opening hours & promotions
function FilterCategory(props: IProps) {
  const { overlay, replacements, setOverlay, country } = props;
  return (
    <div data-testid="workshop-type-dropdown" className={cx('filter-category', { overlay: overlay })}>
      <div className={cx('heading')}>
        <span
          className='link back-link'
          role='link'
          onClick={() => setOverlay(false)}
        ></span>
        <h5>{localesReplacement(replacements, 'FIlters')}</h5>
      </div>
      <div className={cx('inner')}>
        <div className={cx('col')}>
          {/* filter for workshop type */}
          {
            !EUROPEAN_WITHOUT_SERVICE_TYPE_FILTER.includes(country.isoCode) &&
            <WorkShopTypeDropdown />
          }

        </div>
        {country && 'isoCode' in country && country.isoCode !== 'VNM' && (
            <div className={cx('col')}>
              {/* filter for opening hours */}
              <OpeningHoursDropdown />
            </div>
        )}
        {!!country.id && (
          <>
            {_.includes(NODISTANCECOUNTRIES, country.isoCode) ? null : (
              <div className={cx('col')}>
                {/* filter for opening hours */}
                <DistanceDropdown />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
  country: state.country,
});

export default connect(mapStateToProps)(FilterCategory);
